import React from 'react'
import clsx from "clsx"
import SingleRoomSelect from '../../Selects/SingleRoomSelect';
import ServiceLogBuilderErrors from "../ServiceLogBuilderErrors";

export default class ServiceLogBuilderRoom extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "room",
      'tab-pane': true
    });

    var room = I18n.t('not_assigned')
    if (this.props.reservation_segment && this.props.reservation_segment.room) {
      room = this.props.reservation_segment.room
    } else if (this.props.reservation_segment && this.props.reservation_segment.room_group) {
      room = this.props.reservation_segment.room_group
    }

    return (
      <div className={tabClasses} id="room">
        {this.props.errors ? this.renderErrors(this.props.errors) : null}
        <div className="row">
          <div className="col-sm-4 form-group">
              <label>{`${I18n.t('room_id_type')}*`}</label>
            <br />
            <div>
              {this.props.reservation_segment
                  ?
                <div>{room != I18n.t('not_assigned') ? `${room.identifier} (${this.props.reservation_segment.room_type.name})` : room}</div>
                  :
                <SingleRoomSelect className={this.renderFieldClasses('room_id')} room={this.props.service_log.room} room_type={null} onChange={this.props.onChangeRoom} name="room" dateFormat={this.props.date_format} hasError={this.renderFieldClasses('room_id', true)} source={'service_log'} />
              }

            </div>
            {this.renderFieldErrors('room_id')}
          </div>
        </div>   
      </div>
    )
  }

  renderErrors() {
    var errors = ServiceLogBuilderErrors.room(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, noFormControl) {
    if(noFormControl == true) {
      var classname = ''
    } else {
      var classname = 'form-control'
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    } else {
      classname = classname + " no error"
    }
    return classname
  }
}